// Glossary — the access/readiness definitions, tucked behind a toolbar
// button that slides a panel in from the left. Replaces the always-on inline
// Legend on the Timeline: the definitions are one click away without eating
// vertical space above the feed. Content is the shared <Legend />, bare.
import { SideDrawer } from "./SideDrawer";
import { Legend } from "./Legend";

export function Glossary() {
  return (
    <SideDrawer
      width="max-w-md"
      title="Definitions"
      description="What the access + readiness chips on each card mean."
      trigger={
        <button
          type="button"
          className="rounded-md border border-border-hover bg-card/60 px-2 py-1 text-text-tertiary hover:border-text/40 hover:text-text"
          title="What the access + readiness chips mean"
        >
          Definitions
        </button>
      }
    >
      <Legend bare />
    </SideDrawer>
  );
}
